<!-- TODO: Multilang -->

<template>
  <!-- View notifications modal -->
  <v-dialog
    v-model="notificationsDialog"
    persistent
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-badge
          v-if="isUser"
          :content="notifications_count"
          :value="notifications_count"
          overlap
          left
        >
          <v-icon>mdi-email-outline</v-icon>
        </v-badge>
      </v-btn>
    </template>
    <v-card class="qmkey-notifications-table mx-auto">
      <GenericExplorer
        :disabled="mass_reading"
        :key="force_render"
        v-if="apply_filters"
        class="pt-2 pb-7"
        :title="$vuetify.lang.translator('notifications.title')"
        :filters="apply_filters"
        :views="available_views(is_mobile, views_props)"
        hide_add_button
        @update_selection="update_selection"
      >
        <template v-slot:after-title>
          <v-btn
            v-if="notif_selected.length > 0"
            text
            :disabled="mass_reading"
            @click="read_multi_notif"
          >
            <v-icon
              v-if="!mass_reading"
              color="primary"
            >
              mdi-check-all
            </v-icon>
            <v-progress-circular
              v-else
              indeterminate
              color="primary"
              :size="20"
            />

            {{ $t('read') + '  ' + ((notif_selected.length < notifications_count) ? notif_selected.length : $t('all'))}}
          </v-btn>
        </template>
        <template v-slot:extra-header>
          <div>
            <v-btn
              color="black"
              text
              @click="notificationsDialog = false"
            >
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </div>
        </template>
      </GenericExplorer>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import QUnitAPI from '@/api/QUnit'
import Navegation from '@/utils/Navegation';
import QUnitCollection from '@/qunit/QUnitCollection';
import GenericExplorer from '@/components/explorer/GenericExplorer'
import { QFilters, get_qfilter } from '@/qunit/filters';


export default {
  name: 'NotificationsDialog',

  components: {
    GenericExplorer,
  },

  data() {
    return {
      error_message: '',
      jsData: '',
      headers: [
        {
          text: 'Asunto',
          align: 'start',
          sortable: true,
          value: 'subject',
        },
        {
          text: 'Autor',
          sortable: true,
          value: 'author',
        },
        {
          text: 'Fecha',
          sortable: true,
          value: 'date',
        },
        {
          text: 'Estado',
          sortable: true,
          value: 'current_workflow_state_str',
        },
      ],
      search: '',
      loading: false,
      message: '',
      selected: [],
      expanded: [],
      notificationsDialog: false,
      searchClosed: true,
      intervalNotification: null,
      filters: new QFilters(),
      ef_header: null,
      ef_table: null,
      apply_filters: null,
      filter_list: [
        'FilterSearch',
        'FilterDatesRange',
        'FilterAdvanced',
      ],
      clicked_qunit: null,
      title: 'Notificaciones de usuario',
      props: {
        'ExplorerTable': {
          'function': QUnitAPI.getUserNotifications,
          'selectable': true,
          'actions': true,
          'navigate': true,
          'server_pagination': true,
          'checkbox': true,
          'selectable': true,
          'multiselect': true,
          'filter_list': [
            'FilterCentro',
            'FilterSearch',
            'FilterDatesRange',
            'FilterAdvanced',
          ],
          'header_props': {
            'hide_divider': true,
            'hide_tabs': true,
            'header_class': 'qmkey-notification-header',
            'title_class': 'modal-title qmkey-notification-header-title',
          },
          
        },
        'ExplorerCard': {
          'actions': true,
          'navigate': true,
          'checkbox': true,
          'selectable': true,
          'multiselect': true,
          'filter_list': [
            'FilterCentro',
            'FilterSearch',
            'FilterDatesRange',
            'FilterAdvanced',
          ],
          'header_props': {
            'hide_divider': true,
            'hide_tabs': true,
            'hide_filter_chips': true,
            'header_class': 'qmkey-notification-header',
            'title_class': 'modal-title qmkey-notification-header-title',
          },
        },
      },
      qunits_labels: [
        { "value": 'title', "text": 'Asunto', "sortable": 'true' },
        { "value": 'creador', "text": 'Emisor' },
        { "value": 'fecha_creacion', "text": 'Fecha comunicado' },
        { "value": 'current_workflow_state', "text": 'Estado' },
        { "value": 'current_workflow_limit', "text": 'Fecha límite' },
        { "value": 'data-table-expand', "text": '', "sortable": false }
      ],
      force_render: 0,

      notif_selected: [],
      mass_reading: false,
    }
  },

  computed: {
    ...mapGetters([
      'isUser',
      'isManager',
      'isAdmin',
      'sitePath',
      'centro_id',
      'user'
    ]),

    ...mapState([
      'notifications_count',
      'notifications',
      'is_mobile'
    ]),

    views_props() {
      let props =  this.props;
      props['ExplorerTable'].expandable = !this.is_mobile;
      props['ExplorerTable'].navigate_function = this.goToExplorerItem;
      props['ExplorerCard'].navigate_function = this.goToExplorerItem;
      return props;
    },

    qunits() {
      const labels = this.notifications.labels || this.qunits_labels
      return new QUnitCollection({
        units: this.notifications.units,
        labels: labels,
        count: this.notifications.count,
        page: this.notifications.page,
      });
    },
    
  },

  mounted: function () {
    this.loadUserNotificationsCount();
    this.intervalNotification = setInterval(() => this.loadUserNotificationsCount(), 300000);
    this.populate_filters();
  },

  beforeUnmount: function () {
    // Vue3 rename beforeDestroy to beforeUnmount
    clearInterval(this.intervalNotification);
  },
  beforeDestroy: function () {
    // Vue2 name
    clearInterval(this.intervalNotification);
  },

  methods: {
    // TODO:
    goToExplorerItem(notification) {
      // TODO: reset QUnit filters
      this.selected.push(notification);
      this.readNotifications(notification);
      Navegation.goto_qunit_by_uid(this.$router, notification.parent_process,notification.centro);
      // Close Notifications modal
      this.notificationsDialog = false;
    },

    loadUserNotificationsCount() {
      if (this.isUser) {
        QUnitAPI.getUserNotificationsCount(
          this.centro_id,
          'NOTIF_DEFAULT',
          this.user.id
        ).then(data => {
          if (this.notifications_count != data) {
            this.SET_CURRENT_USER_NOTIFICATIONS_COUNT(data);
          }
        }).catch(err => {
          this.loading = false;
          console.error(err);
        });
      }
    },


    populate_filters() {
      this.filters.set_filter(get_qfilter('centro', this.centro_id))
      this.filters.set_filter(get_qfilter('business_process', 'NOTIF_DEFAULT'))
      this.filters.set_filter(get_qfilter('sort_by', "fecha_creacion"))
      this.filters.set_filter(get_qfilter('sort_desc', true))

      this.apply_filters = this.filters.copy()
    },

    readNotifications(notif) {
      var uids = [];
      for (var i = 0; i < this.selected.length; i++) {
        if (!this.selected[i].is_closed) {
          uids.push(this.selected[i].uid);
        }
      }
      if (uids.length > 0) {
        QUnitAPI.executeReadNotifications(
          // TODO: centro id is not Frontend work, it has to be the Backend 
          notif.centro,
          uids
        ).then(data => {
          this.loadUserNotificationsCount();
          // Clean already readed Notifis.
          this.selected = [];
        }).catch(err => {
            this.loading = false;
            console.error(err);
          });
      }
      this.force_render = 1 - this.force_render;
    },
    ...mapActions(['REFRESH_STATE', 'EXPLORE_UNITS']),
    ...mapMutations([
      'SET_SEARCH_TEXT',
      'SET_CURRENT_USER_NOTIFICATIONS',
      'RESET_EXPLORER_FILTERS',
      'SET_CURRENT_USER_NOTIFICATIONS_COUNT',
    ]),
    async refresh(filters) {
      return await QUnitAPI.getUserNotifications(
          filters
        )
          .then(data => {
            this.SET_CURRENT_USER_NOTIFICATIONS(data)
            this.loading = false;
            //Return
            const labels = data.labels || this.qunits_labels
            return new QUnitCollection({...data,'labels': labels})
          })
          .catch(err => {
            console.error(err);
          });
    },
    /* TODO: add cancel token */
    async get_notif(filters,cancel_token) {
      return await this.refresh(filters);
    },

    available_views(is_mobile, props) {
      let views = [{name: 'ExplorerTable',...props['ExplorerTable']}];
      if (is_mobile) {
        views =[{name: 'ExplorerCard',...props['ExplorerCard']}];
      }
      views = views.map(view => ({...view,'function': this.get_notif}));
      return views;
    },

    update_selection(selected) {
      this.notif_selected = selected;
    },

    read_multi_notif() {
      this.mass_reading = true;
      QUnitAPI.executeReadNotifications(this.centro_id,this.notif_selected)
        .then(() => {
          this.loadUserNotificationsCount();
          this.apply_filters = new QFilters(this.apply_filters);
          this.notif_selected = [];
        })
        .finally(()=>{
          this.mass_reading = false;
        })
    }
  },
}
</script>


<style lang="scss">
  @import "@/sass/header.scss";
  .qmkey-notification-filters {
    justify-content: flex-end;
  }
  .qmkey-notification-header {
    display: flex; 
    flex-wrap: wrap; 
    width: 100%; 
    justify-content: space-between;
  }
  .qmkey-notification-header-title {
    white-space: pre-wrap; 
    word-break: break-word;
  }
  .w-100 {
    width: 100%;
  }
</style>
